import React from 'react';
import PropTypes from 'prop-types';
import { Pagination } from 'antd';

const PaginationComponent = props => {
  const { noOfItemsToDisplay, handlePageChange, currentPage, total } = props;
  return (
    <Pagination
      total={total}
      showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
      current={currentPage}
      onChange={handlePageChange}
      pageSize={noOfItemsToDisplay}
      defaultCurrent={1}
    />
  );
};

PaginationComponent.propTypes = {
  noOfItemsToDisplay: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  total: PropTypes.number
};

export default PaginationComponent;
